import cx from 'classnames';
import React, { useLayoutEffect, useRef } from 'react';
import styles from './LoadingOverlay.module.scss';

export const LoadingOverlay = ({
  waiting = true,
  error,
  onButtonClick = () => {},
  inline = false,
  message
}: {
  waiting?: boolean;
  error?: string;
  onButtonClick?: () => void;
  inline?: boolean;
  message?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, []);

  return (
    <div className={cx('loading-overlay', { [styles.inline]: inline })}>
      {error ? (
        <div className={cx(styles.text, styles.textShow)}>{error}</div>
      ) : (
        <>
          <div
            ref={ref}
            className={cx(styles.circleLoader, {
              [styles.loadComplete]: !waiting
            })}
          >
            {!waiting && <div className={cx(styles.checkmark, styles.draw)} />}
          </div>
          {message && (
            <div
              className={cx(styles.text, {
                [styles.textShow]: !waiting
              })}
            >
              {message}
            </div>
          )}
        </>
      )}

      {(!waiting || error) && <button onClick={onButtonClick}>OK</button>}
    </div>
  );
};
